// Shared by both forks.
import React, { createContext, useContext } from 'react';
import type { SearchOptionType, SelectedSearchOption } from '../helpers/types';
import type { SelectedResultsCategory } from '../redesign/constants';

// The old fork has no result categories, so it provides `null` and a no-op setter.
export type SearchScopeContextValue = {
	selectedSearchOptions: SelectedSearchOption[];
	setSelectedSearchOptions: React.Dispatch<React.SetStateAction<SelectedSearchOption[]>>;
	removeSelectedSearchOption: (chipKey: SearchOptionType) => void;
	selectedResultsCategory: SelectedResultsCategory;
	setSelectedResultsCategory: React.Dispatch<React.SetStateAction<SelectedResultsCategory>>;
};

export const SearchScopeContext = createContext<SearchScopeContextValue | null>(null);

export function useSearchScope() {
	const context = useContext(SearchScopeContext);

	if (!context) {
		throw new Error('useSearchScope must be used within a SpotlightStateProvider');
	}

	return context;
}
